module.exports = "../../../../platform/assets/pageMainIcon/simple_baobiaochaxunlei3.svg";